const adminRoutes = [
    {
        path: '/admin',
        name: 'AdminHome',
        component: () => import('@/views/BookingApp/AdminView/Home.vue')
    },
    {
        path: '/admin/appointment',
        name: 'AdminAppointment',
        component: () => import('@/views/BookingApp/AdminView/Appointments/CreateAppointment.vue')
    },
    {
        path: '/admin/appointment/added',
        name: 'AdminAppointmentAdded',
        component: () => import('@/views/BookingApp/AdminView/Appointments/AppointmentAdded.vue')
    },
    {
        path: '/admin/appointment/:id',
        name: 'AdminAppointmentEdit',
        component: () => import('@/views/BookingApp/AdminView/Appointments/UpdateAppointment.vue')
    },
    {
        path: '/admin/appointment/:id/updated',
        name: 'AdminAppointmentUpdated',
        component: () => import('@/views/BookingApp/AdminView/Appointments/AppointmentUpdated.vue')
    },
    {
        path: '/admin/appointment/:id/deleted',
        name: 'AdminAppointmentDeleted',
        component: () => import('@/views/BookingApp/AdminView/Appointments/AppointmentDeleted.vue')
    },
    {
        path: '/admin/treatment',
        name: 'AdminTreatment',
        component: () => import('@/views/BookingApp/AdminView/Treatments/CreateTreatment.vue')
    },
    {
        path: '/admin/treatment/added',
        name: 'AdminTreatmentAdded',
        component: () => import('@/views/BookingApp/AdminView/Treatments/TreatmentAdded.vue')
    },
    {
        path: '/admin/treatment/:id',
        name: 'AdminTreatmentEdit',
        component: () => import('@/views/BookingApp/AdminView/Treatments/UpdateTreatment.vue')
    },



]

export default adminRoutes